import React from 'react';
import PropTypes from 'prop-types';

import { FAQ_INFO_ELEMENTS, FAQ_CONTENT_INFO_ELEMENTS } from '../../../../models//FAQInfoSection';
import { Logger } from '../../../../helpers/Logger';
import { AppLink, routes } from '../../../../routes';
import { UpArrowIcon, DownArrowIcon } from './img';

import styles from './SectionContent.css';

const IPropTypes = {
  title: PropTypes.string.isRequired,
  sectionInfo: PropTypes.array.isRequired,
};

const renderTextElement = textElement => <span key={textElement.id}> {textElement.content} </span>;

const renderLinkElement = (linkElement) => {
  const routeName = routes.find(route => linkElement.route === route.path);
  return (
    <AppLink
      key={linkElement.id}
      className={styles.link}
      routeName={routeName.name}
    >
      {linkElement.content}
    </AppLink>
  );
};

const renderContentElement = bodyElement => (
  <p key={bodyElement.id}>
    {
      bodyElement.content.map((element) => {
        switch (element.type) {
          case FAQ_CONTENT_INFO_ELEMENTS.text:
            return renderTextElement(element);
          case FAQ_CONTENT_INFO_ELEMENTS.link:
            return renderLinkElement(element);
          default:
            return null;
        }
      })
    }
  </p>
);

const renderSectionElement = (element) => {
  switch (element.type) {
    case FAQ_INFO_ELEMENTS.body:
      return renderContentElement(element);
    default:
      Logger.warn('Undefined element type');
  }
  return null;
};

class SectionContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSection: false,
    };
    this._toggleSection = this._toggleSection.bind(this);
  }

  _toggleSection(event) {
    event.preventDefault();
    this.setState(state => ({
      showSection: !state.showSection,
    }));
  }

  render() {
    return (
      <div>
        <button
          className={styles.sectionButton}
          onClick={this._toggleSection}
        >
          {this.props.title}
          {
            this.state.showSection ?
              <img className={styles.arrow} src={UpArrowIcon} alt="" />
            :
              <img className={styles.arrow} src={DownArrowIcon} alt="" />
          }
        </button>
        <div className={this.state.showSection ? styles.sectionInfoOpen : styles.sectionInfoClose}>
          {
            this.state.showSection &&
            this.props.sectionInfo.map(sectionElement => (
              renderSectionElement(sectionElement)
            ))
          }
        </div>
      </div>
    );
  }
}

SectionContent.propTypes = IPropTypes;

export { SectionContent };



// WEBPACK FOOTER //
// ./src/pages/information/help/section-content/SectionContent.jsx